import moment from "moment";
import axios from 'axios';
import {WriteMpCampaignDTO} from "./types";

export function setupTabsEmail(campaign: WriteMpCampaignDTO) {
    return {
        current: 'd',
        total_emails: campaign.emails.count,
        duration: campaign.ui.animate_progress_time,
        reactions: {
            page: 1,
            more: campaign.emails.more,
            loading: false,
            fromId: campaign.emails.fromId,
        },
        prepend_emails: [...campaign.emails.seed.slice(0, campaign.emails.animate_num)],
        emails_seen: false,
        append_emails: [],
        emails: campaign.emails.pre_render_num ? [...campaign.emails.seed.slice(-campaign.emails.pre_render_num)] : [],
        updates: {
            page: 0,
            more: campaign.posts.count > 0,
            fromId: null,
            firstOpen: false
        },
        updates_visible: false,
        window_observer: null,
        toggleUpdatesVisible() {
            if (this.updates.firstOpen === false && this.updates_visible === false) {
                this.updates.firstOpen = true;
                this.loadMoreUpdatesFetch();
            }
            this.updates_visible = !this.updates_visible;
        },
        loadMoreUpdatesFetch() {
            this.updates.page++;
            axios.get(`/petitions/${campaign.petition.slug}/updates`, {
                params: {
                    page: this.updates.page,
                    fromId: this.updates.fromId
                }
            })
                .then(response => {
                    this.$refs.updates.innerHTML += response.data.html;
                    this.updates.more = response.data.more;
                })
                .catch(response => {
                    console.error(response.data);
                });
        },
        loadMoreUpdates: {
            ['@click.prevent'](e) {
                e.preventDefault();
                this.loadMoreUpdatesFetch();
            }
        },
        loadMoreReactions: {
            ['@click.prevent'](e) {
                e.preventDefault();
                if (this.reactions.loading) return;
                this.reactions.loading = true;
                this.reactions.page++;
                axios.get(`/petitions/${campaign.petition.slug}/emails`, {
                    params: {
                        f: 'json',
                        page: this.reactions.page,
                        fromId: this.reactions.fromId,
                    }
                })
                    .then(response => {
                        this.append_emails.push(...response.data.emails);
                        this.reactions.more = response.data.more;
                        this.displayOlderEmails();
                    })
                    .catch(response => {
                        console.error(response.data);
                    })
                    .finally(() => {
                        this.reactions.loading = false;
                    });
            }
        },
        updateEmailsHumanisedTime() {
            this.emails.forEach((comment) => {
                comment.created_at_humanised = moment(comment.created_at).fromNow();
            });
        },
        displayRecentEmails() {
            this.updateEmailsHumanisedTime();
            if (this.prepend_emails.length) {
                this.emails.unshift(this.prepend_emails.pop());
                if (this.prepend_emails.length) {
                    setTimeout(() => this.displayRecentEmails(), campaign.ui.display_new_emails_interval);
                }
            }
        },
        displayOlderEmails() {
            this.updateEmailsHumanisedTime();
            if (this.append_emails.length) {
                this.reactions.loading = true;
                this.emails.push(this.append_emails.shift());
                if (this.append_emails.length) {
                    setTimeout(() => this.displayOlderEmails(), campaign.ui.display_old_emails_interval);
                } else {
                    this.reactions.loading = false;
                }
            }
        },
        setTab(v) {
            this.current = v.substring(0, 1);
            if (this.current === 'r' && !this.emails_seen) {
                this.emails_seen = true;
                this.displayRecentEmails();
            }
            if (v.length > 1) {
                window.location.hash = v;
            }
        },
        animateValue(htmlElement, start, end, duration) {
            let startTimestamp = null;
            const step = (timestamp) => {
                if (!startTimestamp) startTimestamp = timestamp;
                const progress = Math.min((timestamp - startTimestamp) / duration, 1);
                const integerFormat = new Intl.NumberFormat();
                htmlElement.innerHTML = integerFormat.format(Math.floor(progress * (end - start) + start));
                if (progress < 1) {
                    window.requestAnimationFrame(step);
                }
            };
            window.requestAnimationFrame(step);
        },
        checkHash(hash) {
            if (hash && hash.match(/^#(details|reactions)$/)) {
                this.setTab(hash.substring(1));
            }
        },
        init() {
            // Ensure description is visible on desktop (ie when tabs are hidden)
            this.window_observer = new ResizeObserver((entries) => {
                this.current = entries[0].contentRect.width >= 1024 && this.current !== 'd' ? 'd' : this.current;
            });
            this.window_observer.observe(document.querySelector('body'));
            window.addEventListener('hashchange', () => {
                this.checkHash(window.location.hash);
            });
            this.checkHash(window.location.hash);
            const total_elm = document.getElementById('total_emails');
            if (this.total_emails > 1) {
                this.animateValue(total_elm, 0, this.total_emails, this.duration);
            }
            document.addEventListener('stats.update', (e: CustomEventInit<{ total_emails: number, emails: [] }>) => {
                if (e.detail.total_emails > this.total_emails) {
                    this.animateValue(total_elm, this.total_emails, e.detail.total_emails, this.duration);
                    this.total_emails = e.detail.total_emails;
                }
                if (e.detail.emails.length) {
                    this.prepend_emails.unshift(...([...e.detail.emails].reverse()));
                    this.displayRecentEmails();
                }
            });
        }
    };
}
